module.exports = __webpack_public_path__ + "img/cars-es.d333941.webp";